// eslint-disable-next-line no-undef
const API_KEY = process.env.UTIL_APP_BUTTER_CMS_API_KEY;
const TEST_MODE = false;
const TIMEOUT = 30000;
const butter = require("buttercms")(API_KEY, TEST_MODE, TIMEOUT);

export function getPage({ name, levels = 2, overrideLocale = "" }) {
  if (!name) {
    throw Error("Must send at least the name of the page, example: { name: 'footer' }");
  }

  const [, locale, homeMarket = "chile"] = window.location.pathname.split("/");
  if (!["es", "en", "pt"].includes(locale)) {
    throw Error("Locale not supported, locale must be the first value in url, examples: [ /es, /en, /pt ]");
  }

  return butter.page
    .retrieve("*", `${name}-${homeMarket}`, {
      locale: overrideLocale || locale,
      levels,
    })
    .then(function (resp) {
      window.console.log(resp.data);
      return resp.data;
    })
    .catch(function (resp) {
      window.console.warn(resp);
      return resp.data;
    });
}

export function getPageGlobal({ name, levels = 2, overrideLocale = "" }) {
  if (!name) {
    throw Error("Must send at least the name of the page, example: { name: 'footer' }");
  }

  const [, locale] = window.location.pathname.split("/");
  if (!["es", "en", "pt"].includes(locale)) {
    throw Error("Locale not supported, locale must be the first value in url, examples: [ /es, /en, /pt ]");
  }

  return butter.page
    .retrieve("*", `${name}`, {
      locale: overrideLocale || locale,
      levels,
    })
    .then(function (resp) {
      window.console.log(resp.data);
      return resp.data;
    })
    .catch(function (resp) {
      window.console.warn(resp);
      return resp.data;
    });
}

export function getBaseUrl() {
  const [, locale = "es", homeMarket = "chile"] =
    window.location.pathname.split("/");
  return `/${locale}/${homeMarket}`;
}
